import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import type { IconDropdownGroupProps} from '@Components/icon-dropdown-group';
import {IconDropdownGroup} from '@Components/icon-dropdown-group';
import {Option} from '@Components/contextual-menu/components/option';
import styles from '@Components/contextual-menu/contextual-menu.module.scss';

interface ContextualMenuIconDropdownOptionProps {
  id: string;
  className?: string;
  label: string;
  data: Array<IconDropdownGroupProps>;
  children?: ReactNode;
}

export function ContextualMenuIconDropdownOption({children = null, className = '', ...props}: ContextualMenuIconDropdownOptionProps): ReactElement<any> | null {
  const getIconDropdownGroup = (): ReactElement<any> => {
    return (
      <div className={`flex-h-row ${styles.dropdownGroupGap}`}>
        {props.data.map((data) => {
          return (
            <IconDropdownGroup
              id={data.id}
              key={data.id}
              icon={data.icon}
              dropdownPopup={data.dropdownPopup}
              dropdownIcon={data.dropdownIcon}
              onClickDropdownSelector={data.onClickDropdownSelector}
              isIconSelected={data.isIconSelected}
              onClickIcon={(): void => {
                if (data.onClickIcon) data.onClickIcon();
              }}
              dropdownClassName={data.dropdownClassName}
              alignment={data.alignment}
              leftOffset={data.leftOffset}
            />
          );
        })}
      </div>
    );
  };
  return (
    <Option key={props.id} label={props.label} className={className} optionControl={getIconDropdownGroup()}>
      {children}
    </Option>
  );
}
